import Link from 'next/link';
import React from 'react';
import CategoryNavigation from '../../components/CategoryNavigation/CategoryNavigation';
import UniversalLink from '../../components/UniversalLink/UniversalLink';
import { CategoryContainer } from '../../shared-styled/layout/CategoryContainer';
import {
  RegionBox,
  RegionBoxTitle,
} from '../../shared-styled/layout/RegionBox';
import RegionsContainer from '../../shared-styled/layout/RegionsContainer';
import StickyWrapper from '../../shared-styled/layout/StickyWrapper';
import { NoUnderlineAnchorBlock } from '../../shared-styled/typography/Anchors';
import BasePageWrap from '../BasePage';

const WeaponsPage = ({ items }) => (
  <CategoryContainer>
    <StickyWrapper>
      <CategoryNavigation />
    </StickyWrapper>
    <RegionsContainer>
      {items.map((item) => (
        <UniversalLink key={item.title} href={item.url} isBlock={true} passHref>
          <NoUnderlineAnchorBlock>
            <RegionBox $image={item.photo?.path}>
              <RegionBoxTitle>
                {item.title.split(/(\w*\/\b)/g).map((el) => (
                  <span key={el}>
                    {el}
                    <wbr />
                  </span>
                ))}
              </RegionBoxTitle>
            </RegionBox>
          </NoUnderlineAnchorBlock>
        </UniversalLink>
      ))}
    </RegionsContainer>
  </CategoryContainer>
);

export default BasePageWrap(WeaponsPage);
